import shakaPlayer from 'shaka-player';

export default {
    install: function(Vue, options) {
        Object.defineProperty(Vue.prototype, '$shaka', { value: shakaPlayer });
    }
}


// WEBPACK FOOTER //
// ./src/plugins/shakaplayer.js